module.exports = __webpack_public_path__ + "assets/img/ck_img.02f192aa.png";